import React from 'react';

interface ArticleAuthorProps {
    authorContent?: {
        fields?: {
            contentType?: string;
            description?: string;
            title?: string;
        };
    };
}

const ArticleAuthor: React.FC<ArticleAuthorProps> = ({ authorContent }) => {
    const { title, description } = authorContent?.fields || {};

    return (
        <div className='w-full px-2h lg:px-0 pb-3 text-left'>
            {title && <h2 className='text-2xl leading-34 font-semi-bold text-revamp_blueText pb-1 border-b border-solid border-black'>{title}</h2>}
            {description && <p className='text-base lg:text-lg leading-normal font-regular text-revamp_grey_text pt-1 pb-2'>{description}</p>}
        </div>
    );
};

export default ArticleAuthor;